// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { DisplayDueDate } from '../../../../organisms/display-due-date';
import { DisplayTotalAmount } from '../../../../organisms/display-total-amount';
import { ReferenceNumber } from '../reference-number';
import { translate } from '@tectonics/translate';

export function PaymentDetails(): Node {
  return (
    <PaymentDetailsWrapper>
      <TotalAmountAndDueDateBlock>
        <DisplayDueDate label={translate('volcanes.opened-payment.fawry.orderDetail.expirationDate')} redesign={true} />
        <DisplayTotalAmount label={translate('volcanes.opened-payment.fawry.orderDetail.totalAmount')} location="left" redesign={true} />
      </TotalAmountAndDueDateBlock>
      <ReferenceNumberBlock>
        <ReferenceNumber />
      </ReferenceNumberBlock>
    </PaymentDetailsWrapper>
  );
}

const PaymentDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  border: 1px solid rgb(220, 225, 230);
  border-radius: 5px;
`;

const TotalAmountAndDueDateBlock = styled.div`
  display: flex;
  flex-direction: row;
`;

const ReferenceNumberBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid rgb(220, 225, 230);
  padding: 14px;
  gap: 14px;
`;
